document.addEventListener("DOMContentLoaded", function () {
	const scene = document.querySelector('a-scene#main-scene');
	const timeFrames = ['1D', '5D', '1M', '6M', '1Y', '5Y', 'All'];
	const htmlElementsList = [];
	const setCache = (typeof window !== 'undefined' && typeof window.setCacheItem === 'function') ? window.setCacheItem : function(){};

	const mainBlock = document.querySelector('#main-block');
	const bottomControls = document.querySelector('#main-block .bottom-controls');
	let overlayEl = bottomControls?.querySelector('.controls-overlay');
	if (!overlayEl && bottomControls) {
		overlayEl = document.createElement('div');
		overlayEl.className = 'controls-overlay';
		bottomControls.appendChild(overlayEl);
	}

	let popupEl = mainBlock?.querySelector('.interval-hover-popup');
	if (!popupEl && mainBlock) {
		popupEl = document.createElement('div');
		popupEl.className = 'interval-hover-popup';
		popupEl.innerHTML = '<div class="text-primary"></div><div class="text-secondary"></div>';
		mainBlock.appendChild(popupEl);
	}

	timeFrames.forEach((frame) => {
		const htmlElement = document.querySelector(`#main-block .time-range-wrapper .item[data-range='${frame}']`);
		htmlElementsList.push(htmlElement);
		htmlElement.addEventListener('click', () => {
			if (htmlElement.classList.contains('disabled') || htmlElement.classList.contains('active')) return;

			scene.emit('data-interval', { interval: frame });

			const EXPIRATION_TIME = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;
			setCache('data-interval', frame, EXPIRATION_TIME);


			htmlElementsList.forEach(el => el.classList.remove('active'));
			htmlElement.classList.add('active');

			blockingTimelineControlIfNeeded();

			if (window.gtag) gtag('event', `Desktop_CenterPanel_TimeLine`, { period: frame });
		})
	})
	
	function blockingTimelineControlIfNeeded() {
		const chartTypeEl = document.querySelector('#main-block .filters-container .item.active')
		const dataIntervalEl = document.querySelector('#main-block .time-range-wrapper .item.active')
		const playerContainerEl = document.querySelector('#main-block .player-container')
		if (!chartTypeEl || !dataIntervalEl || !playerContainerEl) return;
		
		const chartTypeData = chartTypeEl.dataset.action
		const dataIntervalData = dataIntervalEl.dataset.range
		
		if (chartTypeData === 'topvol' && (dataIntervalData === '5D' || dataIntervalData === '1M') ) {
			playerContainerEl.classList.add('disabled')
		} else {
			playerContainerEl.classList.remove('disabled')
		}
	} 
})
